import React, { Component } from "react";

class BindingBox extends Component {
  render() {
    const { binding, retrieveAccount } = this.props;
    const fontSize = window.innerWidth > 480?"1.5rem":"12px";
    
    return (
      <div className="col-lg-6">
        <div className="number">
          <div className="col-xs-2"> <img src={binding.logo_path} /></div>
          <div className="col-xs-6 box1">
            <p>{binding.game_name}</p>
            <span style={{color: "#747474", lineHeight: "1.5", fontSize: fontSize}}>伺服器：{binding.server_name}</span><br />
            <span style={{color: "#747474", lineHeight: "1.5", fontSize: fontSize}}>角色ID：{binding.role_id}</span> </div>
            <div className="col-xs-4 success"> <span>綁定完成</span> 
            {binding.idx ? 
            (<button style={{backgroundColor: "#676767"}} disabled>找回中</button>) :
            (<button type="button" onClick={(e) => retrieveAccount(binding.role_id)}>找回</button>)
            }
            </div>
        </div>
      </div>
    );
  }
}

export default BindingBox;
